import { fundingRateIsCurrent, fundingSettlementValue, } from '../amount/fx.js';
/** Whole-unit display only; never use rounded indicative bounds for checkout validation. */
export function accountTransactionBounds(options) {
    if (options.direction === 'onramp') {
        const buy = options.buy;
        if (!buy || buy.currency !== options.currency)
            return null;
        const whole = (value) => {
            if (value === null)
                return null;
            const scale = 10n ** BigInt(buy.decimals);
            return ((BigInt(value) + scale / 2n) / scale).toString();
        };
        return {
            minimumUnits: whole(buy.minimumUnits),
            maximumUnits: whole(buy.maximumUnits),
        };
    }
    const fx = options.fx;
    if (!options.sell ||
        !fx ||
        !fundingRateIsCurrent(fx, options.now ?? Date.now()) ||
        !fx.ratesD9[options.currency])
        return null;
    const convert = (value) => value === null ? null : fundingSettlementValue(value, options.currency, 0, fx, 'nearest');
    return {
        minimumUnits: convert(options.sell.minimumD6),
        maximumUnits: convert(options.sell.maximumD6),
    };
}
